import request from '@/api/request'
import store from '@/store'

export function vehicleMonitorTestVinState(vin) {
  return request({
    url: '/vehicleMonitor/testVinState/' + vin,
    method: 'get',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region
    }
  })
}

export function vehicleMonitorSearch(testFlag, vin) {
  let url = '/vehicleMonitor/metrics/'
  if (testFlag) {
    url = '/vehicleMonitor/testVinMetrics/'
  }
  return request({
    url: url + vin,
    method: 'get',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region
    }
  })
}

export function vehicleMonitorUnregisterVin(vin) {
  return request({
    url: '/vehicleMonitor/unregisterODP/' + vin,
    method: 'delete',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region
    }
  })
}

export function vehicleMonitorTransactionState(transactionId) {
  return request({
    url: '/vehicleMonitor/transactionState/' + transactionId,
    method: 'get',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region
    }
  })
}

export function vehicleMonitorSendPayloadCallback(vin, data) {
  return request({
    url: '/vehicleMonitor/clmCallback/' + vin,
    method: 'post',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region
    },
    data: data
  })
}

export function vehicleMonitorSopAdd(data) {
  return request({
    url: '/vehicleMonitor/sop/add',
    method: 'post',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region
    },
    data: data
  })
}

export function vehicleMonitorSopDelete(data) {
  return request({
    url: '/vehicleMonitor/sop/delete',
    method: 'delete',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region
    },
    data: data
  })
}

export function triggerPurchase(vin, transactionId) {
  return request({
    url: '/vehicleMonitor/trigger/purchase/' + vin + '/' + transactionId,
    method: 'put',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region
    }
  })
}

export function checkTransactionState(vin, transactionId) {
  return request({
    url: '/vehicleMonitor/check/transactionstate/' + vin + '/' + transactionId,
    method: 'get',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region
    }
  })
}

export function articlesCapability(vin) {
  return request({
    url: '/vehicleMonitor/articlesCapability/' + vin,
    method: 'get',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region
    }
  })
}

export function vinValidate(vin) {
  return request({
    url: '/vinValidate/' + vin,
    method: 'get',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region
    }
  })
}

